module.exports = {"130526100":"任城镇","130526101":"邢家湾镇","130526102":"辛店镇","130526103":"天口镇","130526200":"西固城乡","130526201":"永福庄乡","130526202":"大屯乡","130526204":"骆庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130526.json
// module id = 139
// module chunks = 0